<script setup>
import AppLogo from '@/components/app/AppLogo.vue'
import {useTeams} from '@/composables/use-teams.js'
import {useNavigation} from '@/composables/use-navigation.js'

//Composables
const {isInTeams} = useTeams()
const {goToHome} = useNavigation()
</script>

<template>
  <div :class="$style.wrapper">
    <div :class="$style.inner">
      <div :class="$style.logoWrapper">
        <AppLogo
          v-if="!isInTeams"
          is-clickable
          @click="goToHome()"
        />
      </div>
    </div>
  </div>
</template>

<style module lang="scss">
.wrapper {
  background: var(--bg-page-top-bar);
  border-bottom: 1px solid var(--color-borders);
  height: var(--topbar-height);
  flex: 0 0 var(--topbar-height);
}
.inner {
  height: 100%;
  max-width: 768px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 auto;
  padding: 0 1.5rem;
  @media (min-width: 768px) {
    padding: 0 2rem;
  }
}
.logoWrapper {
  flex: 1;
}
</style>
